<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <loading :active.sync="isLoading" 
        :can-cancel="true" 
        :is-full-page="fullPage" :color="primary_code"></loading>
    <!-- alert end -->
    <!-- Title-->
    <header-component :headerTitle="headerText" />

    <v-card class="v-card-100">
      <v-card-text style="padding: 32px;">
        <v-row>
          <v-col cols="4" class="pt-7 text-left">
            <span style="font-weight: 600;">Tour Plan Period</span>
          </v-col>
          <v-col cols="4">
            <v-menu v-model="menu1" :close-on-content-click="false" :return-value.sync="from_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedFromDate" label="From" prepend-inner-icon="mdi-calendar" readonly v-bind="props" disabled></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="new Date().toISOString().substr(0, 10)" :max="maxDate"  v-model="isDatePickerFromDate" hide-header color="primary" min-width="200" max-width="300" scrollable :allowed-dates="allowDates" >
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="menu1 = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('menu1', 'from_date', 'isDatePickerFromDate', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-menu v-model="menu2" :close-on-content-click="false" :return-value.sync="to_date" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="formattedToDate" label="To" prepend-inner-icon="mdi-calendar" readonly v-bind="props" disabled></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker :min="new Date().toISOString().substr(0, 10)" :max="maxDate" v-model="isDatePickerToDate" hide-header color="primary" min-width="200" max-width="300" scrollable :allowed-dates="allowDates">
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="menu2 = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none" @click="handleSaveDate('menu2', 'to_date', 'isDatePickerToDate', true, '', '')">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
            <div v-if="error" class="error-message">{{ error }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100 select-card">
      <v-card-text style="padding: 32px;">
        <v-row>
          <v-col cols="4" class="pt-7 text-left">
            <span style="font-weight: 600;">Select Method</span>
          </v-col>
          <v-col cols="8">
            <v-radio-group row inline="" v-model="selectDetails">
              <v-radio  :label="role == 'area_service_manager' ? 'Dealer Wise' : 'Service Manager Wise'" value="sales_manager_wise" style="margin-right: 409px;" class="radio-content" disabled></v-radio>
              <v-radio  label="Date Wise" value="date_wise" class="radio-content"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100 select-card" v-if="selectDetails === 'sales_manager_wise'">
      <v-card-text style="padding: 32px;">
        <v-row v-for="(manager, index) in salesManagers" :key="index">
          <v-col cols="4" :class="{ 'pt-7': index === 0 }" class="text-left">
            <span v-if="index === 0" style="font-weight: 600;">Add Date</span>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="manager.manager_name" label="Service Manager" variant="outlined">
              <template v-slot:append>
                <v-icon color="primary" cursor="pointer" @click="detailPopup(manager)">mdi-information-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="4">
            <div v-for="(s_date,index2) of manager.dateList" :key="index2">
              <div class="d-flex">
                <v-menu v-model="s_date.visitDate" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ props }">
                      <v-text-field variant="outlined" color="primary" v-model="s_date.dateFormatted" :label="`Visit Date ${index2 + 1}` " prepend-inner-icon="mdi-calendar" readonly v-bind="props" :disabled="s_date.disable"></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                    <v-date-picker :min="from_date" :max="min_available_date" v-model="s_date.visit_date" hide-header color="primary" min-width="200" max-width="300" :allowed-dates="allowDates" @update:modelValue="updateFormattedDate(s_date)" scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" color="primary" class="text-none" @click="menu2 = false">Cancel</v-btn>
                      <v-btn variant="text" color="primary" class="text-none" @click="s_date.visitDate = false">Ok</v-btn>
                    </v-card-action>
                  </v-card>
                </v-menu>
                <span class="ml-3 mt-4" style="font-size: 18px;">
                  <v-icon v-if="index2 == 0" style="color: red;" @click="eraseDate(s_date,manager,index2)">mdi-eraser</v-icon>
                  <v-icon v-else style="color: red;" @click="deleteDate(manager,index2,s_date)" :disabled="s_date.disable">mdi-delete</v-icon>
                </span>
              </div>
              <!-- Add more button -->
              <div class="text-end" v-if="index2 == manager.dateList.length-1">
                <a style="color: #1976d2;" @click="addVisitDateField(index)">
                  <u>+Add Date</u>
                </a>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" class="p-0">
            <v-card-actions class="float-right">
              <v-btn variant="flat" color="primary" class="text-none" size="large" :disabled="isResubmitDisabled" @click="resubmit('sales_manager_wise')">Re-Submit</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="v-card-100 select-card" v-if="selectDetails === 'date_wise'">
      <v-card-text style="padding: 32px;">
        <v-row v-for="(manager, index) in dateWiseManagers" :key="index" v-if="role != 'area_service_manager'">
          <v-col cols="4" class="pt-7">
            <span style="font-weight: 600;" v-if="index == 0">Add Dealers</span>
          </v-col>
          <v-col cols="4">
            <v-menu v-model="manager.visitDate2" :close-on-content-click="false"  transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                  <v-text-field variant="outlined"
                  v-model="manager.formatted_visit_date2"
                  label="Visit Date"
                  prepend-inner-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :disabled="true"
                  >
                  </v-text-field>
              </template>
              <v-date-picker v-model="manager.visit_date2" :min="from_date" :max="to_date" no-title scrollable @update:modelValue="updateFormattedDateVisit(manager)">
                  <v-spacer></v-spacer>
                  <v-btn class="text-none" color="primary" @click="handleCancelVisit2(manager)">Cancel</v-btn>
                  <v-btn class="text-none" color="primary" @click="manager.visitDate2 = false">Ok</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <div v-for="(s_manager,index2) of manager.managerList" :key = "index2" class="text-left">
              <v-autocomplete v-model="s_manager.manager" :items="availableManagers(manager.managerList, s_manager.manager)" item-title="manager_name" item-value="sales_manager_id" label="Service Manager" variant="outlined" :disabled="manager.disable"></v-autocomplete>
              <div class="text-end" v-if="index2 == manager.managerList.length-1">
                <a style="color: #1976d2;" @click="addSalesManager(index)" :disabled="manager.disable">
                  <u>+Add Service Manager</u>
                </a>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-for="(vendor, index) in salesManagersDateWise" :key="index" v-if="role == 'area_service_manager'">
          <v-col cols="4" :class="{ 'pt-7': index === 0 }" class="text-left">
            <span v-if="index === 0" style="font-weight: 600;">Add Vendors</span>
          </v-col>
          <v-col cols="2">
            <v-menu v-model="vendor.visitDate2" :close-on-content-click="false" :return-value.sync="vendor.visitDate" transition="scale-transition" offset-y  min-width="290px">
              <template v-slot:activator="{ props }">
                  <v-text-field variant="outlined" color="primary" v-model="vendor.formatted_visit_date3" label="Visit Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props" ></v-text-field>
              </template>
              <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                <v-date-picker  :min="from_date" :max="to_date"  v-model="vendor.visitDate" hide-header color="primary" scrollable  min-width="200" max-width="300">
                </v-date-picker>
                <v-card-action class="d-flex justify-end pb-3">
                  <v-spacer></v-spacer>
                  <v-btn variant="text" color="primary" class="text-none" @click="vendor.visitDate2 = false">Cancel</v-btn>
                  <v-btn variant="text" color="primary" class="text-none"  @click="handleSaveDate(vendor)">Ok</v-btn>
                </v-card-action>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-autocomplete  class="text-left" v-model="vendor.vendor" label="Type of Vendor" prepend-inner-icon="mdi-magnify" :items="['Dealer','Partner']" variant="outlined"/>
          </v-col>
          <v-col cols="2">
            <v-autocomplete  class="text-left" v-model="vendor.customer_name" label="Customer Name" prepend-inner-icon="mdi-magnify" :items="customerDetails" variant="outlined"
            item-title="cutomer_name" item-value="cutomer_id" @update:modelValue="updateVendorLocation(vendor)" return-object/>
          </v-col>
          <v-col cols="2" class="d-flex flex-column">
            <v-autocomplete v-model="vendor.location" label="Location" prepend-inner-icon="mdi-magnify" variant="outlined" :disabled="!vendor.customer_name"
            :items="vendor.list" item-title="address_detail" multiple  return-object chips  class="custom-height">
              <template v-slot:selection="data">
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-chip
                      v-bind="props"
                      class="mr-2"
                      :key="data.item.id"
                      variant="outlined"
                    >
                      {{ data.item.address_detail }}
                    </v-chip>
                  </template>
                  <span>{{ data.item.address_detail }}</span>
                </v-tooltip>
              </template>
            </v-autocomplete>
            <div>
              <span class="float-right">
                <v-icon  class="mr-2" color="primary" style="border: 1px solid; border-radius: 4px;" @click="addNewVendor">mdi-plus</v-icon>
                <v-icon  class="mr-2" color="error" style="border: 1px solid; border-radius: 4px;" @click="DeleteVendor(index)" :disabled="salesManagersDateWise.length == 1">mdi-delete-outline</v-icon>
              </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" class="p-0">
            <v-card-actions class="float-right">
              <v-btn variant="flat" color="primary" class="text-none" @click="resubmit('date_wise')">Re-Submit</v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {
    HeaderComponent,Loading
  },
  data() {
    return {
      headerText: "Tour Plan",
      alert: false,
      alert_type: "success",
      alert_message: '',
      menu1: false,
      to_date: null,
      menu2: false,
      from_date: null,
      error : '',
      selectDetails : 'date_wise',
      salesManagers: [],
      salesManagersDateWise : [],
      customerDetails: [],
      visitDate2 : false,
      visit_date2 : null,
      id : '',
      tour_id : '',
      original_details : [],
      date_wise_manager_details : [],
      dateWiseManagers : [
        { visit_date2 : null, visitDate2 : false,managerList : [{ manager : ''}] }
      ],
      fullPage : true,
      isLoading : false,
      primary_code: "#0275d8",
      isDatePickerFromDate: new Date(),
      isDatePickerToDate: new Date(),
      manager_name_id_mapping : [],
    }
  },
  created(){
    this.id = this.$store.state.lotIds;
    this.tour_id = this.$store.state.inventoryId
    this.role = this.$store.state.currentUser.roles[0]
    const from_confirmEditLot = this.$store.state.direction
    if(from_confirmEditLot){
      this.selectDetails = this.$store.state.selected_method
      const params = this.$store.state.params
      this.from_date = params.tour_start_date
      this.to_date = params.tour_end_date
      this.id = params.id;
      if(this.selectDetails == 'date_wise'){
        if(this.$store.state.currentUser.roles.includes('area_service_manager')){
          this.salesManagersDateWise = this.$store.state.sales_info
          this.getDropDownData()
        }
        else this.dateWiseManagers = this.$store.state.sales_info
      } else{
        this.salesManagers = this.$store.state.sales_info
      }
    } else if(this.$store.state.currentUser.roles.includes('area_service_manager')){
      this.getDropDownData(this.id)
    }else{
      this.getSalesManagerList();
    }
  },
  computed: {
    formattedFromDate(){
      if (this.from_date) {
        const date = new Date(this.from_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    formattedToDate(){
      if (this.to_date) {
        const date = new Date(this.to_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return '';
    },
    formattedVisitDate(){
      if (this.visit_date) {
        const date = new Date(this.visit_date);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return '';
    },
    maxDate() {
      const currentDate = new Date();
      let endOfNextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);
      endOfNextMonth.setHours(23, 59, 59, 999);
      return endOfNextMonth.toISOString().substr(0, 10);
    },
    isResubmitDisabled() {
      return this.salesManagers.every(manager =>
        manager.manager_name === '' || 
        manager.dateList.length === 0 || 
        manager.dateList.every(s_date => !s_date.dateFormatted)
      );
    },
    checkResubmitDisableDatewise(){
      return this.dateWiseManagers.every(manager =>
        manager.managerList.every(s_manager => !s_manager.manager)
      )
    },
    min_available_date(){
      var f_date = new Date(this.from_date)
      var t_date = new Date(this.to_date)
      f_date.setHours(0, 0, 0, 0)
      t_date.setHours(0, 0, 0, 0)
      return this.to_date
    }
  },
  watch: {
    'manager.visit_date'(newDate) {
      if (newDate) {
        const parts = newDate.split('/');
        this.manager.formattedVisitDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
      } else {
        this.manager.formattedVisitDate = '';
      }
    },
    'manager.dateList': {
      handler(newVal) {
        newVal.forEach(visitDate => {
          this.updateFormattedDate(visitDate);
        });
      },
      deep: true
    },
  },
  methods : {
    updateFormattedDateVisit1(vendor) {
      if (vendor.visitDate) {
        const date = new Date(vendor.visitDate);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        vendor.formatted_visit_date3 = `${dd}/${mm}/${yyyy}`; 
      } else {
        vendor.formatted_visit_date3 = '';
      }
    },
    handleCancel(visitDate,visitIndex,manager){
      visitDate.visit_date = null;
      visitDate.visitDate = false;
      visitDate.dateFormatted = null;
      manager.dateList.splice(visitIndex+1,visitDate.count);
    },
    updateFormattedDate(visitDate) {
      const date = new Date(visitDate.visit_date);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const today_date = new Date();
      visitDate.dateFormatted = `${day}/${month}/${year}`;
    },
    availableManagers(manager_list, currentManager) {
      const selectedManagers = manager_list.map(manager => manager.manager);
      return this.date_wise_manager_details.filter(manager => 
        !selectedManagers.includes(manager.sales_manager_id) || manager.sales_manager_id === currentManager
      );
    },
    updateFormattedDateVisit(manager){
      const date = new Date(manager.visit_date2);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      manager.formatted_visit_date2 = `${dd}/${mm}/${yyyy}`;
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {this.alert = false;}, 3000);
    },
    addVisitDateField(index) {
      const newVisitDate = {
        visit_date: null,
        visitDate: true,
      };
      this.salesManagers[index].dateList.push({visit_date: null, visitDate: false,})
    },
    getSalesManagerList(){
      this.isLoading = true;
      this.$httpSecured
        .get(`/api/v1/warehouse/fta/tour_plan/tours/get_sales_managers`)
        .then(response => {
          this.isLoading = false;
          this.date_wise_manager_details = response.data.sales_managers
          this.manager_name_id_mapping = {}
          this.date_wise_manager_details.forEach(item => {
            item.manager_name = `${item.sales_manager} (${item.sales_manager_id})`,
            this.manager_name_id_mapping[item.sales_manager_id] = {
             manager_name :  `${item.sales_manager} (${item.sales_manager_id})`,
             sales_manager_name : item.sales_manager,
            }
          })
        })
        .catch(error => {
          this.isLoading = false
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    getTourPlanDetail(id) {
      this.isLoading = true;
      this.$httpSecured
        .get(`/api/v1/warehouse/fta/tour_plan/tours/${id}`)
        .then(response => {
          if (response.data  && response.data['fta/tour_plan/tour']) {
            this.isLoading = false
            const resp = response.data['fta/tour_plan/tour']
            this.original_details = resp
            this.from_date = resp.tour_start_date
            this.to_date = resp.tour_end_date
            const groupedVisits = {};
            this.salesManagersDateWise = []
            resp.list_of_visit.forEach(visit => {
              const matchedCustomer = this.customerDetails.find(customer => customer.cutomer_name === visit.dealer_name)
              const vendor = {
                visitDate: new Date(visit.visit_date),
                customer_name: matchedCustomer ? matchedCustomer.cutomer_id : null,
                vendor: "Dealer",
                location: visit.address ? [visit.address] : [],
                list: visit.address ? [visit.address] : [],
                'formatted_visit_date3' : visit.visit_date.split('-').reverse().join('/')
              };
              this.salesManagersDateWise.push(vendor);
            });
           resp.list_of_visit.forEach(visit => {
              const managerKey = `${visit.sales_manager} (${visit.sales_manager_id})`;
              if (!groupedVisits[managerKey]) {
                groupedVisits[managerKey] = {
                  manager_name: managerKey,
                  sales_manager : visit.sales_manager,
                  sales_manager_id : visit.sales_manager_id,
                  sales_manager_user_id : visit.sales_manager_user_id,
                  dateList: []
                };
              }
              const min_available_date = new Date(this.min_available_date)
              var is_disabled = visit.visit_date ? new Date(visit.visit_date) > min_available_date : false
              groupedVisits[managerKey].dateList.push({
                visit_date: visit.visit_date,
                visitDate: false,
                dateFormatted: visit.visit_date ? visit.visit_date.split('-').reverse().join('/') : null,
                disable : is_disabled,
              });
            });
            this.salesManagers = Object.values(groupedVisits);
            this.salesManagers.forEach(item=>{
              item.dateList.forEach(date=>{
                var count = 0
                if(!date.disable){
                  var passible_date1 = new Date(date.visit_date)
                  var passible_date2 = new Date(date.visit_date)
                  passible_date1.setDate(passible_date1.getDate() + 14)
                  passible_date2.setDate(passible_date2.getDate() + 28)
                  item.dateList.forEach(date_check=>{
                    if(passible_date1.getTime() == new Date(date_check.visit_date).getTime() || passible_date2.getTime() == new Date(date_check.visit_date).getTime())
                      count+=1
                  })
                }
                date.count = count
              })
            })
            this.date_wise_manager_details.forEach(item => {
              if(!this.salesManagers.some(manager=> manager.manager_name == item.manager_name)){
                this.salesManagers.push({ manager_name : item.manager_name, sales_manager : item.sales_manager,
                  sales_manager_id : item.sales_manager_id, sales_manager_user_id : item.sales_manager_user_id, dateList : [{visit_date : null, visitDate : false, disable : false }]})
              }
            })
            this.dateWiseManagers = []
            const fromDate = new Date(this.from_date);
            const toDate = new Date(this.to_date);
            for (let currentDate = new Date(fromDate); currentDate <= toDate; currentDate.setDate(currentDate.getDate() + 1)){
              const dd = String(currentDate.getDate()).padStart(2, '0');
              const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
              const yyyy = currentDate.getFullYear();
              const min_available_date = new Date(this.min_available_date)
              var is_disabled = currentDate > min_available_date
              this.dateWiseManagers.push({ 
                visitDate2 : false, 
                visit_date2 : `${yyyy}-${mm}-${dd}`,
                formatted_visit_date2: `${dd}/${mm}/${yyyy}`,
                disable : is_disabled,
                managerList : [ { manager : null}]
              })
            }
            resp.list_of_visit.forEach(visit => {
              this.dateWiseManagers.forEach(data => {
                if(data.visit_date2 == visit.visit_date){
                  if(!data.managerList[0].manager)  
                    data.managerList[0].manager = visit.sales_manager_id
                  else data.managerList.push({ manager : visit.sales_manager_id})
                }
              })
            })
          } else {
            this.isLoading = false
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.isLoading = false
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    eraseDate(item,manager,index){
      item.visit_date = null
      item.dateFormatted = null
      manager.dateList.splice(index+1,item.count)
    },
    deleteDate(item,index,visitDate){
      item.dateList.splice(index,visitDate.count+1);
    },
    addNewVendor(){
      this.salesManagersDateWise.push({ 'visitDate' : new Date(this.from_date), 'vendor' : 'Dealer', 'customer_name' : null, 'location': null , 'date_model' : false, list: [], 'formatted_visit_date3' : this.from_date.split('-').reverse().join('/') })
    },
    DeleteVendor(index){
      this.salesManagersDateWise.splice(index,1)
    },
    getDropDownData(id){
      this.$httpSecured
      .get("api/v1/warehouse/fta/tour_plan/tours/get_customers")
      .then((response)=>{
        this.customerDetails = response.data.customers
        if(id)
          this.getTourPlanDetail(id);
      })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      })
    },
    updateVendorLocation(vendor){
      this.$httpSecured
      .get(`/api/v1/warehouse/fta/tour_plan/tours/get_customers_address?id=${vendor.customer_name.cutomer_id}&dealer_code=${vendor.customer_name.customer_dealer_code}`)
      .then((response)=>{
        const addresses = response.data.addresses;
          if (addresses.length === 1) {
            vendor.location = addresses;
          }
          vendor.list = addresses;
          })
      .catch(error => {
        this.$toast.error(error.response.data.message)
      })
    },
    resubmit(action){
      let planned_count;
      if(action == 'date_wise'){
        const uniqueManagers = new Set();
        this.dateWiseManagers.forEach(item => {
            item.managerList.forEach(temp => {
              if(temp.manager)
                uniqueManagers.add(temp.manager.sales_manager);
            });
        });
        planned_count = uniqueManagers.size;
      } else {
        planned_count = Array.from(new Set(this.salesManagers.filter(item => item.manager_name && item.dateList[0].visit_date ))).length
      }
      let params = {
        'id' : this.id,
        'tour_start_date' : this.from_date,
        'tour_end_date' : this.to_date,
        'tour_method' : '',
        'sales_manager_name' : this.original_details.sales_manager_name,
        'sales_manager_id' : this.original_details.sales_manager_id,
        'tour_plan_summary' : {
          'total_sales_manager' : this.role == 'area_service_manager' ? this.original_details.total_sales_manager : this.date_wise_manager_details.length,
          'total_planned_sales_manager' : this.role == 'area_service_manager' ? this.original_details.total_planned_sales_manager : planned_count,
          'total_unplanned_sales_manager' : this.role == 'area_service_manager' ? this.original_details.total_unplanned_sales_manager : this.date_wise_manager_details.length - planned_count,
          'visit_summary' : [],
        }
        }
      if(action == 'date_wise'){
        params.tour_method = 'date_wise';
        this.dateWiseManagers.forEach(item => {
          item.managerList.forEach(manager =>{
            if(manager.manager)
              params.tour_plan_summary.visit_summary.push({
                'date' : item.visit_date2, 
                'sales_managers' : manager.manager ? manager.manager : null,
                'manager_name' : manager.manager ? this.manager_name_id_mapping[manager.manager].manager_name : null,
                'sales_manager_name' : manager.manager ? this.manager_name_id_mapping[manager.manager].sales_manager_name : null
              })
          })
        })
        if(this.role == 'area_service_manager'){
          params.tour_method = 'date_wise';
          this.salesManagersDateWise.forEach(item => {
            item.location.forEach(loc =>{
              const matchedCustomer = this.customerDetails.find(customer => customer.cutomer_id === item.customer_name)
              params.tour_plan_summary.visit_summary.push({
                'date' : this.backend_date_format(item.visitDate),
                'customer_name' : matchedCustomer ? matchedCustomer : item.customer_name,
                'vendor' : item.vendor,
                'address' : loc.id,
                'address_name' : loc.address_detail
              })
            })
          })
        }
      } else {
        params.tour_method = 'sales_manager_wise';
        this.salesManagers.forEach(item => {
          item.dateList.forEach(manager =>{
            params.tour_plan_summary.visit_summary.push({'date' : manager.visit_date, 
              'sales_managers' : item.sales_manager_id,
              'sales_manager_name' : item.sales_manager,
              'manager_name' : item.manager_name
            })
          })
        })
      }
      this.$store.commit("setFtaConfirmationInfo", {
        params : params,
        sales_info : action == 'date_wise' ? this.role == 'area_service_manager' ? this.salesManagersDateWise : this.dateWiseManagers : this.salesManagers,
        selected_method : action,
        direction : false,
        tour_id : this.tour_id
      });
      this.$router.push({ name: "confirmEditLot" });
    },
    handleCancelVisit2(manager){
      manager.visit_date2 = null;
      manager.visitDate2 = false;
    },
    addSalesManager(index){
      if(!this.dateWiseManagers[index].disable)
        this.dateWiseManagers[index].managerList.push({ manager : ''});
    },
    allowDates(date) {
      const dayOfWeek = new Date(date).getDay();
      return dayOfWeek !== 0;
    },
    allowDates1(date,index,visitIndex){
      let allowed = true
      this.salesManagers[index].dateList.forEach((v_date,v_index)=>{
        if(v_index != visitIndex && v_date.visit_date == date) allowed = false;
      })
      return allowed;
    },
    handleSaveDate(vendor){
      vendor.visitDate2 = false
      if (vendor.visitDate) {
        const date = new Date(vendor.visitDate);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        vendor.formatted_visit_date3 = `${dd}/${mm}/${yyyy}`;
      } else {
        vendor.formatted_visit_date3 = '';
      }
    },
    backend_date_format(date_value){
      if (date_value) {
        const date = new Date(date_value);
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
      }
      return ''
    }
  }
}
</script>
<style scoped>
.select-card {
  border-top: 21px solid #E5E5E5
}
:deep(.custom-height .v-field__field) {
  /* padding: 0 12px !important; */
  height: 56px !important;
  overflow-y: scroll !important;

}

</style>